const CANCEL_CHOICE = Symbol('NO_CHOICE');
export default CANCEL_CHOICE;
